











import { Vue, Component, Prop } from 'vue-property-decorator';

import { ICustomerImportStatus } from '@/models/customer-import';

import CustomerImportInProgress from '@/componentsV2/templates/CustomerImportInProgress/CustomerImportInProgress.vue';

import { ECustomerImportSteps } from '../CustomerImportModal.vue';

@Component({
  components: {
    CustomerImportInProgress
  }
})
export default class ImportInProgress extends Vue {
  @Prop({ default: false }) isVisible?: boolean;

  handleFailed(customerImportStatus: ICustomerImportStatus) {
    this.$emit('customer-import-event', {
      type: 'goToStep',
      params: { goToStep: ECustomerImportSteps.ERROR }
    });
  }

  handleCompleted(customerImportStatus: ICustomerImportStatus) {
    this.$emit('customer-import-event', {
      type: 'goToStep',
      params: {
        goToStep: ECustomerImportSteps.IMPORT_SUCCESS,
        stepProps: customerImportStatus
      }
    });
  }

  handleKeepExploring() {
    this.$emit('customer-import-event', { type: 'closeModal' });
  }
}
